import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CreatePrestationPage } from '@/features/prestations/components/CreatePrestationPage';

const searchSchema = z.object({
  duplicateFrom: z.coerce.number().int().positive().optional(),
});

export const Route = createFileRoute('/$commiteeSlug/prestation/create')({
  component: CreatePrestationPage,
  validateSearch: searchSchema,
});
